<div class="exception-body access-page">

    <div class="exception-top">
        <img src="assets/layout/images/icon-access.png" alt="poseidon-layout" />
    </div>

    <div class="exception-bottom">
        <div class="exception-wrapper">
            <span class="exception-summary">Access Denied</span>
            <span class="exception-detail">You Don't Have Permissions To Access This Resource</span>
            <button pButton pRipple [routerLink]="['/']" label="Dashboard" icon="pi pi-home"></button>
            <a [routerLink]="['/']" class="logo">
                <img src="assets/layout/images/logo.svg" alt="poseidon-layout" class="logo-icon"  />
            </a>
            <span class="exception-footer">PrimeNG Poseidon</span>
        </div>
    </div>
</div>
